module.exports = __webpack_public_path__ + "img/9788964231739.84517a28.jpg";